export const ProductsPagePublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">제품 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">카테고리</label>
                            <select className="form-select w-150px">
                                <option>전체</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">검색어</label>
                            <select className="form-select w-150px">
                                <option>전체</option>
                            </select>
                            <input type="text" className="form-control w-250px ms-5px" />
                            <button className="btn btn-info btn_search ms-5px">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="row mb-15px">
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">결과 내 검색</label>

                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row search">
                            <select className="form-select w-150px">
                                <option>조회</option>
                            </select>
                            <input type="text" className="form-control w-250px ms-5px" />
                            <button className="btn btn-info btn_search ms-5px">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                            <button className="btn btn-primary w-100px">구매 가이드</button>
                        </div>
                    </div>
                </div>

                <div className="products_container">
                    <div className="left">
                        <table className="table table-bordered my_table">
                            <thead>
                                <tr>
                                    <th style={{ width: "21.8%" }}>이미지</th>
                                    <th style={{ width: "68.6%" }}>상품 상세</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {[0, 1, 2].map(() => (<tr className="h-166px">
                                    <td className="p-4px"><img src={process.env.PUBLIC_URL + "/assets/images/ex_image_lg.png"} alt="" width={288} /></td>
                                    <td>
                                        <div className="line0 mb-5px">[Microsoft] Compact</div>
                                        <div className="line1 mb-3px">S1-WIN Emb Compact 7 C7E</div>
                                        <div className="line2 mb-16px">TNA-00022</div>
                                        <div className="line3_lg">설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다. 설명칸입니다.설명칸입니다...</div>
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column justify-content-center align-items-center">
                                            <button className="btn btn-outline-dark w-110px mx-0 mb-5px px-0"><img className="me-5px" src={process.env.PUBLIC_URL + "/assets/images/icon_shopping_cart.png"} alt="" />장바구니</button>
                                            <button className="btn btn-dark  mx-0 w-110px">구매하기</button>
                                        </div>
                                    </td>
                                </tr>))}
                            </tbody>
                        </table>
                    </div>
                    <div className="right">
                        <div className="recent_top">구매내역</div>
                        <div className="recent_content">
                            <ul className="recent_list">
                                <li>
                                    <a href="#/link-1">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#/link-1">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#/link-1">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a href="#/link-1">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/ex_image_sm.png"} alt="" />
                                    </a>
                                </li>
                            </ul>
                            <div className="recent_bottom">
                                <button className="btn btn-outline-light btn_history_pg"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"} alt="" /></button>
                                <button className="btn btn-outline-light btn_history_pg"><img className="m-0" src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"} alt="" /></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}